module.exports = __webpack_public_path__ + "static/media/maersk-logo-rgb.3d315da0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maersk-logo-rgb.svg
// module id = 108
// module chunks = 0